/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid.ts";

function getDeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidUrl(
  classModuleId: DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/classroomdiscipline/grade-and-frequence/class-modules/${classModuleId}` as const,
  };
  return res;
}

/**
 * @description Remove o vínculo das Aulas informadas com o Módulo. Aulas que não pertencem ao Módulo são ignoradas. **(Requer Authorization para autenticação)**
 * @summary Desanexar Aulas do Módulo (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/grade-and-frequence/class-modules/:classModuleId}
 */
export async function deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid(
  classModuleId: DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"],
  data?: DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest,
  config: Partial<
    RequestConfig<DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404
      | DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500
    >,
    DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest
  >({
    method: "DELETE",
    url: getDeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidUrl(
      classModuleId,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
